import { useState } from "react";
import { createPortal } from "react-dom";

const fieldStyle = {
    width: '100%', padding: '11px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4,
    boxSizing: 'border-box', fontSize: 14, background: 'white',
    outline: 'none', color: '#0f172a',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
    cursor: 'pointer', transition: 'border-color .15s',
};

export const SeleccionIcono = ({ value, options = [], onChange, placeholder = 'Seleccione un icono' }) => {

    const [open, setOpen] = useState(false);
    const [busqueda, setBusqueda] = useState('');

    const selected = options.find(o => o.value === value);

    const filtradas = busqueda.trim()
        ? options.filter(o => (o.nombre || '').toLowerCase().includes(busqueda.trim().toLowerCase()))
        : options;

    const elegir = (opcion) => {
        onChange(opcion);
        setOpen(false);
        setBusqueda('');
    };

    return (
        <div style={{ marginTop: 0 }}>
            <button
                type="button"
                onClick={() => setOpen(true)}
                style={{
                    ...fieldStyle,
                    borderColor: value ? 'var(--color-primario)' : '#cbd5e1',
                    background: value ? '#ecfdf5' : 'white',
                }}
            >
                {selected ? (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 700, fontSize: 13.5 }}>
                        <i className={selected.value} style={{ fontSize: 18, color: 'var(--color-primario-texto)', width: 24, textAlign: 'center' }}></i>
                        <span style={{ textTransform: 'capitalize' }}>{selected.nombre}</span>
                    </span>
                ) : (
                    <span style={{ color: '#94a3b8' }}>{placeholder}</span>
                )}
                <i className="fa-solid fa-chevron-down" style={{ fontSize: 12, color: '#94a3b8' }}></i>
            </button>

            {open && createPortal(
                <div
                    style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(15, 23, 42, 0.55)', backdropFilter: 'blur(4px)',
                        zIndex: 12000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
                    }}
                    onClick={() => setOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: '#ffffff', borderRadius: 20, width: '100%',
                            maxWidth: 640, maxHeight: '78vh', display: 'flex', flexDirection: 'column',
                            overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.3)', border: '1px solid #e2e8f0',
                        }}
                    >
                        {/* Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                            padding: '16px 22px', color: 'var(--color-primario-contraste)',
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
                                <div style={{
                                    width: 36, height: 36, borderRadius: 10,
                                    background: 'rgba(255,255,255,0.18)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    <i className="fa-solid fa-icons"></i>
                                </div>
                                <div>
                                    <h4 style={{ margin: 0, fontWeight: 800, fontSize: 16 }}>Seleccionar icono</h4>
                                    <p style={{ margin: '2px 0 0', opacity: 0.85, fontSize: 12 }}>
                                        {filtradas.length} de {options.length} iconos disponibles
                                    </p>
                                </div>
                            </div>
                            <button type="button" onClick={() => setOpen(false)} style={{
                                background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                                width: 32, height: 32, borderRadius: '50%', fontSize: 15, cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}><i className="fa-solid fa-xmark"></i></button>
                        </div>

                        {/* Buscador */}
                        <div style={{ padding: '14px 22px', borderBottom: '1px solid #f1f5f9', position: 'relative' }}>
                            <i className="fa-solid fa-magnifying-glass" style={{
                                position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)',
                                color: '#94a3b8', fontSize: 13, pointerEvents: 'none',
                            }} />
                            <input
                                type="text"
                                autoFocus
                                placeholder="Buscar icono..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                style={{
                                    width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                    border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                    background: '#f8fafc', color: '#0f172a',
                                }}
                                onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                            />
                        </div>

                        {/* Cuadrícula */}
                        <div style={{ padding: '16px 22px', overflowY: 'auto', flex: 1 }}>
                            {filtradas.length === 0 ? (
                                <div style={{ padding: '40px 0', textAlign: 'center', color: '#94a3b8' }}>
                                    <div style={{ fontSize: 32, marginBottom: 10 }}>
                                        <i className="fa-solid fa-circle-question"></i>
                                    </div>
                                    <div style={{ fontWeight: 700, fontSize: 14 }}>
                                        No hay iconos que coincidan con la búsqueda
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                                    {filtradas.map((opcion) => {
                                        const activo = opcion.value === value;
                                        return (
                                            <button
                                                key={opcion.value}
                                                type="button"
                                                onClick={() => elegir(opcion)}
                                                title={opcion.nombre}
                                                style={{
                                                    width: 84, padding: '10px 4px', borderRadius: 12, cursor: 'pointer',
                                                    border: activo ? '2px solid var(--color-primario)' : '1.5px solid #e2e8f0',
                                                    background: activo ? '#ecfdf5' : '#ffffff',
                                                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                                                    transition: 'border-color .15s, background .15s',
                                                }}
                                                onMouseEnter={(e) => { if (!activo) e.currentTarget.style.borderColor = 'var(--color-secundario)'; }}
                                                onMouseLeave={(e) => { if (!activo) e.currentTarget.style.borderColor = '#e2e8f0'; }}
                                            >
                                                <i className={opcion.value} style={{ fontSize: 22, color: activo ? 'var(--color-primario)' : '#334155' }}></i>
                                                <span style={{
                                                    fontSize: 10, color: '#64748b', fontWeight: 700, width: '100%',
                                                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                                    textTransform: 'capitalize', textAlign: 'center',
                                                }}>
                                                    {opcion.nombre}
                                                </span>
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '12px 22px', borderTop: '1px solid #f1f5f9', background: '#f8fafc',
                            display: 'flex', justifyContent: 'flex-end',
                        }}>
                            <button type="button" onClick={() => setOpen(false)} style={{
                                padding: '10px 22px', borderRadius: 10, border: 'none',
                                background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 13.5,
                                display: 'inline-flex', alignItems: 'center', gap: 8,
                            }}>
                                <i className="fa-solid fa-check"></i> Cerrar
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};